"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBodyParts = void 0;
const react_1 = require("react");
const useCircularArray_1 = require("../../hooks/useCircularArray");
const types_1 = require("../types");
const useBodyParts = ({ defaultSide, defaultGender, bodyParts }) => {
    const [selectedBodyParts, setSelectedBodyParts] = (0, react_1.useState)(bodyParts);
    const { currentValue: side, nextValue: nextSideValue, next: nextSide, setCurrentValueByValue: setSide, } = (0, useCircularArray_1.useCircularArray)(Object.values(types_1.BodyPartPickerSide), defaultSide);
    const { currentValue: gender, setCurrentValueByValue: setGender, next: nextGender, nextValue: nextGenderValue, } = (0, useCircularArray_1.useCircularArray)(Object.values(types_1.BodyPartPickerGender), defaultGender);
    const handleBodyPartClick = (event) => {
        const clickedBodyPartId = event.target.id;
        if (!clickedBodyPartId)
            return selectedBodyParts;
        if (selectedBodyParts.includes(clickedBodyPartId)) {
            const newParts = selectedBodyParts.filter((bodyPartId) => bodyPartId !== clickedBodyPartId);
            setSelectedBodyParts(newParts);
            return newParts;
        }
        else {
            const newParts = [...selectedBodyParts, clickedBodyPartId];
            setSelectedBodyParts(newParts);
            return newParts;
        }
    };
    const clearParts = () => {
        setSelectedBodyParts([]);
    };
    const switchToMale = () => {
        return setGender(types_1.BodyPartPickerGender.Male);
    };
    const switchToFemale = () => {
        return setGender(types_1.BodyPartPickerGender.Female);
    };
    const switchGender = () => {
        return nextGender();
    };
    const switchSide = () => {
        return nextSide();
    };
    return {
        side,
        nextSideValue,
        gender,
        nextGenderValue,
        selectedBodyParts,
        handleBodyPartClick,
        clearParts,
        switchGender,
        switchToMale,
        switchToFemale,
        setSide,
        switchSide,
        setGender,
    };
};
exports.useBodyParts = useBodyParts;
//# sourceMappingURL=useBodyParts.js.map